import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'namelize' })
export class NamelizePipe implements PipeTransform {

    transform(value: any) {
        if (value) {
            return value.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }

        return value;
    }

}